/**
 * @desc 返回没有r和code的接口地址
 */
const whiteListUrl = [
    '/mng/org/getOrgAndUserTreeNodes',
    '/mng/role/PackageQuota',
    '/mng/org/getUserTreeNodes',
    '/mng/role/GetPrivilegesList',
    '/mng/org/changeTerminalPrivilegesDetection',
    // 微信小程序账号
    '/mp/oauth/url',
    '/call/miniProgram/unbindQDMiniProgram',
    '/call/miniProgram/url',
    // 公众号账号
    '/mp/accountInfo/getAccountInfo',
    // 公众号账号刷新状态
    '/mp/accountInfo/getWxMaterial',
];

export default whiteListUrl;
